<template lang="pug">
div
  .game-tab-container
    .swiper.mySwiper(ref="mySwiper")
      .swiper-wrapper
        .game-thumb-img.swiper-slide.ef-time-content(v-for="item in gamesList" :class="'sports-' + item" @click="setMenuEF(item)")
          img.img-fluid(:src="params[item].thumbnail")
          .ef-time
      .swiper-pagination
  .swiper
    .swiper-wrapper
      .swiper-slide
        //- small {{ key3 }} 
        template(v-if="keys.length <= 0")
          .mt-1(:class="'sports-' + menu2")
            .round-alert {{ $t('message.no_event') }}
        template(v-else)
          .egame-video-container
            .video-container(:class="'sports-' + menu2")
              iframe(:src="getPlayer()", frameborder="0", allowfullscreen="true", scrolling="no" loading="lazy")
            template(v-if="keys.length > 0")
              template(v-for="(ml, mk) in key3")
                template(v-if="items[ml].sportsId == menu2")
                  template(v-for="(ll, lk) in items[ml].leagueList")
                    template(v-if='efightList.includes(parseInt(ll.sportsId))')
                      template(v-for="(mml, mmk) in ll.matchList")
                        efItem1.m-0.mt-1(:source="mml", :index="parseInt(mmk)", :key="mml.id")
                    template(v-else)
                      efGroup(:source="ll.matchList" :sportsType="ll.sportsId")
          .btn-wrapper(v-if="keys.length > 0")
            template(v-if="whiteLabel")
              a.btn-result(
                v-if="info.id != null"
                :href="'/efresult?q=' + info.id + '&n=' + encodeURI(info.type.replace('+', '$')) "
              )
                img.img-fluid(src='images/egame/result-icon.svg')
            template(v-else)
              a.btn-result(
                v-if="info.id != null"
                :href="'/efresult?q=' + info.id + '&n=' + encodeURI(info.type.replace('+', '$')) "
                target="_blank"
                onclick="event.stopPropagation();window.open(this.href,'efresult','top=10,height=auto,width=950,status=no,toolbar=no,menubar=no,location=no');return false;"
              )
                img.img-fluid(src='images/egame/result-icon.svg')
            .btn-collapse.close-all(@click="toggleAll()")
          .accordion-all-games
            template(v-if="keys.length > 0")
              template(v-for="(ml, mk) in key2")
                template(v-if="items[ml].sportsId == menu2")
                  template(v-for="(ll, lk) in items[ml].leagueList")
                    template(v-if='efightList.includes(parseInt(ll.sportsId))')
                      template(v-for="(mml, mmk) in ll.matchList")
                        efItem1(:source="mml", :index="parseInt(mmk)", :key="mml.id")
                    template(v-else)
                      efGroup(:source="ll.matchList" :sportsType="ll.sportsId")
            template(v-else)
              .eracing-mainmarket-group
                .preloader(v-if="keys.length > 0")
                  .loader
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {
    efGroup: () => import("@/components/mobile/efight/efGroup"),
    efItem1: () => import("@/components/mobile/efight/efItem1")
  },
  props: {
    keys: {
      type: Array
    },
    key1: {
      type: Array
    },
    key2: {
      type: Array
    },
    key3: {
      type: Array
    },
    items: {
      type: Object
    }
  },
  data() {
    return { 
      state: {
        GET_LIVE: false,
        GET_NONLIVE: false,
        GET_MARKET: false,
        INVALIDATE: false
      },
      diff: 0,
    }
  },
  computed: {
    params() {
      return config.params;
    },
    efightList() {
      return config.efightList;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    newFeatures() {
      return config.newFeatures;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    info() {
      var result = {
        id: null,
        type: null
      };
      if (this.keys.length > 0) {
        if (this.items != null && this.items.hasOwnProperty(this.keys[0])) {
          result.id = this.items[this.keys[0]].sportsId;
          result.type = this.items[this.keys[0]].sportsType;
        }
      }
      return result;
    },
    gamesList() {
      return config.gamesList 
    }
  },
  watch: { },
  destroyed() {
    window.removeEventListener("message", this.receiveMessage);
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage, false);
    // EventBus.$on("SET_EGAME_SLIDE", this.setSlide);
    var _this = this;
    let swiperOptions = {
      simulateTouch: true,
      spaceBetween: 0,
      slidesPerView: 3,
      loopedSlides: 0,
      loop: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      initialSlide: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: false,
      },
      on: {
        slideChangeTransitionStart: function() {
          const slide = _this.$refs.mySwiper.swiper.realIndex;
          const gamesList = config.gamesList;
          
          if (slide >= 0 && slide < gamesList.length) {
            const gameId = parseInt(gamesList[slide], 10);
            _this.setMenuEF(gameId);
          }
        }
      }
    }

    var swiper = new Swiper(".mySwiper", swiperOptions);

    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // fetch("https://mywbet88.com/timezone?tz=" + tz)
    //   .then((response) => response.json())
    //   .then((data) => {
    //     this.diff = new Date(data.datetime).getTime() - new Date().getTime();
    //     this.countDown();
    //   });
    
    try {
      fetch("https://mywbet88.com/timezone?tz=" + tz)
        .then((response) => response.json())
        .then((data) => {
          this.diff = new Date(data.datetime).getTime() - new Date().getTime();
          this.countDown();
        });
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    runLive(e) {
      this.state.GET_LIVE = true;
      setTimeout(() => {
        this.state.GET_LIVE = false;
      }, 1000);
    },
    runNonLive(e) {
      this.state.GET_NONLIVE = true;
      setTimeout(() => {
        this.state.GET_NONLIVE = false;
      }, 2000);
    },
    handleLive(e) {
      this.counter.GET_LIVE = e;
    },
    handleNonLive(e) {
      this.counter.GET_NONLIVE = e;
    },
    handleMarket(e) {
      this.counter.GET_MARKET = e;
    },
    runMarket(e) {
      this.state.GET_LIVE = true;
      this.state.GET_NONLIVE = true;
      this.state.GET_MARKET = true;
      setTimeout(() => {
        this.state.GET_LIVE = false;
        this.state.GET_NONLIVE = false;
        this.state.GET_MARKET = false;
      }, 3000);
    },
    runInvalidate(e) {
      this.state.GET_LIVE = true;
      this.state.GET_NONLIVE = true;
      this.state.GET_MARKET = true;
      this.state.INVALIDATE = true;
      setTimeout(() => {
        this.state.GET_LIVE = false;
        this.state.GET_NONLIVE = false;
        this.state.GET_MARKET = false;
        this.state.INVALIDATE = false;
      }, 5000);
    },
    getTimer(e) {
      const dt = new Date(new Date().getTime() + this.diff);
      let n = dt.getMinutes();
      let f1 = Math.floor(n / this.params[e].duration);
      let f2 = Math.floor(n % this.params[e].duration);
      let f3 = f1 * this.params[e].duration + this.params[e].delay;
      let f4 = f3;
      if (f3 <= n) {
        f4 = f3 + this.params[e].duration;
      }
      let s = dt.getSeconds();
      let m = s == 0 ? f4 - n : f4 - n - 1;
      if (s != 0) {
        s = 60 - s;
      }

      var mmm = this.params[e].duration - this.params[e].live;
      // console.log(e, mmm, m, s);
      if (m >= mmm) {
        return '<div class="live-label blink-now">' + this.$t("ui.live") + "</div>";
      } else {
        if (m == 0 && s <= 30) {
          return '<div class="live-label blink-now">' + this.$t("ui.live") + "</div>";
        } else {
          return '<div class="time-label">' + `${m}:${s < 10 ? "0" + s : s}` + "</div>";
        }
      }
    },
    countDown() {
      for (var m = 0; m < this.gamesList.length; m++) {
        $(".sports-" + this.gamesList[m] + " .ef-time").html(this.getTimer(this.gamesList[m]));
      }
      setTimeout(this.countDown, 1000);
    },
    toggleAll() {
      var elem = $(".btn-collapse");
      var isOpenAll = elem.hasClass("open-all");
      elem.toggleClass("open-all", !isOpenAll).toggleClass("close-all", isOpenAll);
      setTimeout(() => {
        $(".collapse").toggleClass("show", isOpenAll);
        $(".collapse-head").toggleClass("collapsed", !isOpenAll).attr("aria-expanded", isOpenAll);
      }, 100);
    },
    setMenuEF(mode) {
      // console.log('setMenuEF', mode)
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = "all";
      mi5["menu1"] = "today";
      mi5["menu2"] = parseInt(mode);
      mi5["menu3"] = "hdpou";

      var options = {};
      options[mi5["menu2"]] = true;
      this.$store.dispatch("layout/setOptions", { property: "live", value: options });
      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE");
      // this.$router.push("/prematch");
    },
    receiveMessage(event) {
      const message = event.data.message;

      switch (message) {
        case "videoLink":
          // console.log("videoLink", event.data.value);
          if (event.data.value.name == "Play") {
            $("#videoLink").addClass("esports-play");
          } else {
            $("#videoLink").removeClass("esports-play");
          }
          break;
      }
    },
    getPlayer() {
      return (
        config.player10Url() +
        config.gameStream[this.menu2 + (this.newFeatures ? 100 : 0)] +
        "&u=" +
        this.$store.getters.accountId +
        "&t=" +
        this.$store.getters.sessionToken +
        "&product=" +
        this.menu2 +
        "&counter=" +
        this.counter
      );
    },
  }
}
</script>